export const CREATE_USER = 'CREATE_USER';
export const FETCH_USER = 'FETCH_USER'; //FETCHING A RECORD
export const FETCH_USERS = 'FETCH_USERS'; //FETCHING A LIST
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';